exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".component-container{border-top:1px solid #9b9b9b;border-bottom:1px solid #9b9b9b;padding:22px 0;display:flex;width:100%;flex-direction:column}@media (max-width:1024px){.component-container{padding:22px;margin-top:24.5px}}.component-container .title{font-size:20px!important;font-family:Avenir-Heavy;margin-bottom:15px;color:#000}@media (max-width:1024px){.component-container .title{font-size:16px!important}}.component-container .param{margin:7.5px 0;font-size:15px!important}", ""]);

// exports
